import { newPiece } from "./pieces";

const r = (n) => Math.round(n * 10) / 10;
const ALL = { C1: true, C2: true, L1: true, L2: true };
const FRONT = { C1: true, C2: false, L1: false, L2: false };
const LONG = { C1: true, C2: true, L1: false, L2: false };
const TOP = { C1: false, C2: true, L1: false, L2: false };
const NONE = { C1: false, C2: false, L1: false, L2: false };
const hingeQty = (h) => (h <= 900 ? 2 : h <= 1500 ? 3 : h <= 1900 ? 4 : 5);

function mk(mat, mod, name, length, width, qty, extra = {}) {
  return newPiece(mat, { name, length: r(length), width: r(width), qty, module: mod, edges: NONE, ...extra });
}

const fitsSheet = (a, b) => Math.max(a, b) <= 2730 && Math.min(a, b) <= 1830;

function panel(mat, mod, name, L, W, qty, extra = {}) {
  if (fitsSheet(L, W)) return [mk(mat, mod, name, L, W, qty, extra)];
  let n = 2;
  while (!fitsSheet(L >= W ? L / n : L, L >= W ? W : W / n) && n < 10) n++;
  const [pl, pw] = L >= W ? [L / n, W] : [L, W / n];
  return [mk(mat, mod, `${name} (dividido em ${n})`, pl, pw, qty * n, extra)];
}

function drawers(M, mod, W, D, T, fronts, frontW = W - 8, opt = {}) {
  const hidden = M.slide === "oculta";
  // hidden slides always use an 18 mm drawer box
  const DT = hidden ? 18 : M.drawer?.thickness || 15;
  const vao = W - 2 * T, inner = hidden ? vao - 57 : vao - 26 - 2 * DT;
  const Dd = D - (M.inset || 0);
  const slideL = hidden ? Math.max(250, Math.floor((Dd - 50) / 50) * 50) : Math.max(250, Math.floor((Dd - 30) / 50) * 50);
  const boxL = slideL;
  const out = [];
  const groove = { enabled: true, side: "C1", offset: 12, depth: 8, width: 6.6 };
  const groups = {};
  fronts.forEach((h) => (groups[h] = (groups[h] || 0) + 1));
  Object.entries(groups).forEach(([fh, n]) => out.push(mk(M.front, mod, "Frente de gaveta", frontW, fh, n, { edges: ALL, ...(opt.internal ? { internal: true } : {}) })));
  // side height from the free opening: telescopic 20 + 25 per extra drawer, hidden 25 + 40 per extra drawer
  const n = fronts.length, Hv = opt.clear ?? fronts.reduce((a, h) => a + +h, 0) + 4 * (n - 1) + 8;
  const hg = opt.sideH || Math.max(60, r(hidden ? (Hv - 25 - 40 * (n - 1)) / n : (Hv - 20 - 25 * (n - 1)) / n));
  const dm = { ...(M.drawer || { ...M.body, thickness: 15 }), thickness: DT };
  if (hidden) {
    out.push(mk(dm, mod, `Lateral de gaveta (corrediça oculta ${slideL}mm)`, boxL, hg, 2 * n, { thickness: DT, edges: TOP,
      groove: { enabled: true, side: "C1", offset: 12, depth: Math.min(14, DT - 4), width: 6.6 }, rabbet: { enabled: true, side: "C1", width: 12, depth: 8, over: 5 } }));
    out.push(mk(dm, mod, "Frente/traseira interna gaveta", inner, opt.innerH || hg - 25, 2 * n, { thickness: DT, edges: TOP }));
    out.push(mk(M.back, mod, "Fundo de gaveta", inner + 26, boxL - 2, n));
  } else {
    out.push(mk(dm, mod, `Lateral de gaveta (corrediça telescópica ${slideL}mm)`, boxL, hg, 2 * n, { thickness: DT, edges: TOP, groove }));
    out.push(mk(dm, mod, "Frente/traseira interna gaveta", inner, opt.innerH || hg - 5, 2 * n, { thickness: DT, edges: TOP, groove }));
    out.push(mk(M.back, mod, "Fundo de gaveta", inner + 14, boxL - 2 * DT + 14, n));
  }
  return out;
}

const r1 = (x) => Math.round(x * 10) / 10;
export const ripado = (v) => {
  const hz = v.orientacao === 1, H = hz ? Math.min(1820, Math.max(300, v.altura)) : v.altura;
  const span = hz ? H : v.largura, len = hz ? Math.min(2730, v.largura) : H;
  const ends = v.inicio === 1, max = Math.floor(span / v.ripa);
  const n = Math.max(ends ? 2 : 1, Math.min(ends ? v.espacos + 1 : v.espacos - 1, max));
  const spaces = ends ? n - 1 : n + 1;
  const gap = (span - n * v.ripa) / spaces, start = ends ? 0 : gap;
  const cnt = len <= 800 ? 2 : len <= 1500 ? 3 : 4, edge = len < 500 ? 100 : 150;
  const ys = Array.from({ length: cnt }, (_, i) => r1(edge + ((len - 2 * edge) * i) / (cnt - 1)));
  return { n, gap, cnt, ys, start, spaces, hz, H, len, W: hz ? len : v.largura };
};
const splitFronts = (H, n) => Array.from({ length: n }, () => r((H - 8 - (n - 1) * 4) / n));
const doorsW = (W, n) => r((W - 8 - (n - 1) * 4) / n);
export const topDrawers = (H, n) => Math.max(1, Math.min(n, Math.floor((H - 4 - 200) / 153)));
const dims = (w, h, d, extra = []) => [
  { key: "largura", label: "Largura (mm)", def: w[0], min: w[1], max: w[2] },
  { key: "altura", label: "Altura (mm)", def: h[0], min: h[1], max: h[2] },
  { key: "profundidade", label: "Profundidade (mm)", def: d[0], min: d[1], max: d[2] },
  ...extra,
];
const doorsParam = (def = 2) => ({ key: "portas", label: "Portas (0 = sem porta)", def, min: 0, max: 2 });
const shelvesParam = (def = 1, max = 5) => ({ key: "prateleiras", label: "Prateleiras", def, min: 0, max });
const BOX = ["body", "front", "back"];
const divParam = (def) => ({ key: "divisorias", label: "Divisórias verticais internas (base ao topo)", def, min: 0, max: 6 });
export const wardrobeDivs = (v, inner, T) => Math.max(0, Math.min(v.divisorias, Math.floor((inner + T) / (150 + T)) - 1));
// Bay widths; aéreo with 3 doors gets one divider at a door joint (larger bay left or right), 4 doors one in the centre
export const bayWidths = (v, inner, T) => {
  const wr = "rodape_on" in v;
  const auto = "lado_maior" in v && (v.portas === 3 || (!wr && v.portas >= 3) || (v.portas === 0 && v.div_pos > 0));
  // sliding wardrobe: one divider per door joint (2→1, 3→2, 4→3), equal bays
  const sl = wr && !("lado_maior" in v) && v.portas > 0;
  const n = auto ? 1 : sl ? v.portas - 1 : ("div_pos" in v && v.portas === 0) ? 0 : wardrobeDivs(v, inner, T), total = inner - n * T;
  // divider centred on the 4 mm gap between doors 1|2 (or 2|3); same rule without doors
  const emb = v.montagem === 1 && v.portas === 3, dW = (v.largura - 16 - (emb ? 2 * T : 0)) / 3;
  const s = dW + 6 - T / 2 - (emb ? 0 : T);
  if (auto && v.portas === 0 && v.div_pos !== 2) return v.div_pos === 1 ? [s, total - s] : [total - s, s];
  if (auto && v.portas === 3) return v.lado_maior === 0 ? [total - s, s] : [s, total - s];
  return Array(n + 1).fill(total / (n + 1));
};
export const DRAWER_FRONT_H = 180;
const bayRows = (shelves, withDrawers, withDiv = true, count = (v) => v.divisorias) => Array.from({ length: 7 }, (_, i) => [
  { key: `prat_${i + 1}`, label: `Vão ${i + 1} — prateleiras`, short: "Prateleiras", row: i + 1, def: shelves, min: 0, max: 8, when: (v) => i <= count(v) },
  ...(withDrawers ? [{ key: `gav_${i + 1}`, label: `Vão ${i + 1} — gavetas`, short: "Gavetas", row: i + 1, def: 0, min: 0, max: 8, when: (v) => i <= count(v) }] : []),
  ...(withDiv ? [{ key: `div_${i + 1}`, label: `Vão ${i + 1} — divisória interna (altura mm, 0 = sem)`, short: "Divisória (mm, 0 = sem)", row: i + 1, def: 0, min: 0, max: 2700, when: (v) => i <= count(v) }] : []),
]).flat();
const wardrobeParams = (shelves, hinged = false) => [
  ...(hinged ? [
    { key: "lado_maior", label: "Vão maior (2 portas)", def: 0, choices: [[0, "À esquerda"], [1, "À direita"]], when: (v) => v.portas === 3 },
    { key: "div_pos", label: "Divisória vertical", def: 0, choices: [[0, "Sem divisória"], [1, "Lado esquerdo"], [2, "Centro"], [3, "Lado direito"]], when: (v) => v.portas === 0 },
    { ...divParam(1), when: (v) => v.portas !== 3 && v.portas !== 0 },
  ] : [{ ...divParam(1), when: (v) => v.portas === 0 }]),
  { key: "rodape_on", label: "Rodapé", def: 1, choices: [[1, "Com rodapé (por fora)"], [0, "Sem rodapé"]], inline: "rodape" },
  { key: "rodape", label: "Altura do rodapé (mm)", def: 100, min: 30, max: 300, inlined: true, when: (v) => v.rodape_on === 1 },
  ...bayRows(shelves, true, true, hinged ? (v) => (v.portas === 3 ? 1 : v.portas === 0 ? (v.div_pos > 0 ? 1 : 0) : v.divisorias) : (v) => (v.portas ? v.portas - 1 : v.divisorias)),
];
// Total height includes the rodapé frame, which sits outside/below the carcass
const withRodape = (v) => ({ ...v, altura: v.altura - (v.rodape_on ? v.rodape : 0) });
const rodapeFrame = (M, m, v, T, inner, D, n) => (v.rodape_on ? [
  mk(M.body, m, "Rodapé frente / trás", inner + 20, v.rodape, 2, { edges: FRONT }),
  mk(M.body, m, "Rodapé lateral (por dentro)", D - 100 - 2 * T, v.rodape, 2, {}),
  ...(n ? [mk(M.body, m, "Rodapé divisória (por dentro)", D - 100 - 2 * T, v.rodape, n, {})] : []),
] : []);
// Vertical dividers from base to top; shelves (5 mm shallower than dividers) and drawers per vão; spacers keep drawers clear of hinges
const wardrobeInside = (M, m, v, T, inner, divD, hinged, maleiro = true) => {
  const ws = bayWidths(v, inner, T), n = ws.length - 1, cols = n + 1, shelfD = divD - 5;
  const same = ws.every((w) => r(w) === r(ws[0]));
  const out = [
    ...(n ? [mk(M.body, m, "Divisória vertical", v.altura - 2 * T, divD, n, { edges: FRONT })] : []),
    ...(maleiro && same ? [mk(M.body, m, "Maleiro", r(ws[0]), shelfD, cols, { edges: FRONT })] : []),
  ];
  for (let i = 1; i <= cols; i++) {
    const vao = r(ws[i - 1]);
    if (maleiro && !same) out.push(mk(M.body, m, `Maleiro vão ${i}`, vao, shelfD, 1, { edges: FRONT }));
    const q = v[`prat_${i}`] || 0, g = v[`gav_${i}`] || 0, dh = Math.min(v[`div_${i}`] || 0, v.altura - 2 * T);
    if (dh > 0) out.push(mk(M.body, m, `Divisória interna vão ${i} (${dh}mm)`, dh, shelfD, 1, { edges: FRONT }));
    if (q > 0) {
      out.push(dh > 0
        ? mk(M.body, m, `Prateleira vão ${i} (dividida)`, r((vao - T) / 2), shelfD, q * 2, { edges: FRONT })
        : mk(M.body, m, `Prateleira vão ${i}`, vao, shelfD, q, { edges: FRONT }));
    }
    if (g > 0) {
      // hinged (and sliding 3 doors, vão 2): 2 spacers, opening vão - 80 - 2T, front vão - 90; sliding: 1 spacer, vão - 25 - 2T, front vão - 50
      const two = hinged || (v.portas === 3 && i === 2);
      // wardrobe drawers: 180 mm fronts with 5 mm gaps, 165 mm sides, 150 mm inner front/back
      const sides = two ? 2 : 1, open = vao - (two ? 80 : 25) - 2 * T, stack = g * (DRAWER_FRONT_H + 5);
      // spacer lateral 25 mm shallower than the gaveteiro top
      out.push(mk(M.body, m, `Lateral afastador de gaveta vão ${i}`, stack + T, shelfD - 25, sides, { edges: FRONT }));
      out.push(mk(M.body, m, `Régua 40mm do afastador vão ${i}`, stack + T, 40, sides * 2, {}));
      out.push(mk(M.body, m, `Tampo do gaveteiro vão ${i}`, vao, shelfD, 1, { edges: FRONT }));
      out.push(...drawers(M, `${m} · vão ${i}`, open + 2 * T, divD, T, Array(g).fill(DRAWER_FRONT_H), r(vao - (two ? 90 : 50)), { clear: stack, internal: true, sideH: 165, innerH: 150 }));
    }
  }
  return out;
};
// Back split per vão; joints land on the centre of each divider
const wardrobeBacks = (M, m, b, v, T, inner, nh) => {
  const ws = bayWidths(v, inner, T), n = ws.length - 1;
  if (b.none) return [];
  if (!n) return backPanel(M, m, b, v.largura, v.altura, T, nh);
  const H = b.emb ? v.altura - nh * T + nh * 10 - 2 : v.altura - 2;
  const joints = ws.slice(0, -1).map((_, i) => T + ws.slice(0, i + 1).reduce((a, c) => a + c, 0) + (i + 0.5) * T);
  const edges = [b.emb ? T - 10 + 1 : 1, ...joints, b.emb ? v.largura - T + 10 - 1 : v.largura - 1];
  return edges.slice(0, -1).flatMap((x, i) => {
    const w = r(edges[i + 1] - x - (i > 0 ? 1 : 0) - (i < n ? 1 : 0));
    return panel(M.back, m, `Fundo vão ${i + 1}${b.emb ? ` embutido (rebaixo ${b.rw}mm)` : ""}`, w, H, 1);
  });
};
const fundoParam = { key: "fundo_tipo", label: "Fundo", def: 0, choices: [[0, "Por fora (sobreposto)"], [1, "Embutido (rebaixo)"], [2, "Sem fundo"]] };
// Embedded back: rabbet 13 mm (18 mm box) / 10 mm (15 mm box), 10 mm deep into laterals, base and top
const backOpt = (v, M) => {
  const T = M.body.thickness, emb = v.fundo_tipo === 1, rw = emb ? (T === 18 ? 13 : T === 15 ? 10 : M.back.thickness + 1) : 0;
  return { emb, none: v.fundo_tipo === 2, rw, rab: emb ? { rabbet: { enabled: true, side: "C2", width: rw, depth: 10 } } : {} };
};
const backPanel = (M, m, b, W, H, T, nh, name = "Fundo") => (b.none ? [] : b.emb
  ? panel(M.back, m, `${name} embutido (rebaixo ${b.rw}mm)`, W - 2 * T + 20 - 2, H - nh * T + nh * 10 - 2, 1)
  : panel(M.back, m, name, W - 2, H - 2, 1));

function cabinetWithDoors(v, M, m) {
  const T = M.body.thickness, b = backOpt(v, M), D = v.profundidade;
  const doorW = doorsW(v.largura, v.portas);
  return [
    mk(M.body, m, "Lateral", v.altura, D, 2, { edges: FRONT, ...b.rab }),
    mk(M.body, m, "Base / Topo", v.largura - 2 * T, D, 2, { edges: FRONT, ...b.rab }),
    ...(v.prateleiras > 0 ? [mk(M.body, m, "Prateleira", v.largura - 2 * T, D - 20 - b.rw, v.prateleiras, { edges: FRONT })] : []),
    ...backPanel(M, m, b, v.largura, v.altura, T, 2),
    ...(v.portas > 0 ? [mk(M.front, m, "Porta", v.altura - 8, doorW, v.portas, { edges: ALL, hinge: { qty: hingeQty(v.altura), side: "C1" } })] : []),
  ];
}

const NICHO_INFERIOR = {
  key: "nicho_inferior",
  name: "Nicho inferior de cozinha",
  desc: "Balcão aberto ou com portas, com prateleiras e fundo por fora, embutido ou sem fundo.",
  materials: BOX,
  params: dims([600, 100, 1500], [720, 300, 1000], [550, 250, 700], [
    { key: "portas", label: "Portas (0 = sem porta)", def: 0, min: 0, max: 2 },
    shelvesParam(1, 4),
  ]),
  build: (v, M) => {
    const T = M.body.thickness, m = "Nicho inferior", b = backOpt(v, M), D = v.profundidade, W = v.largura, H = v.altura;
    return [
      mk(M.body, m, "Lateral", H, D, 2, { edges: FRONT, ...b.rab }),
      mk(M.body, m, "Base", W - 2 * T, D, 1, { edges: FRONT, ...b.rab }),
      mk(M.body, m, "Travessa superior", W - 2 * T, 100, 2, { edges: FRONT }),
      ...(v.prateleiras > 0 ? [mk(M.body, m, "Prateleira", W - 2 * T, D - 20 - b.rw, v.prateleiras, { edges: FRONT })] : []),
      ...backPanel(M, m, b, W, H, T, 1),
      ...(v.portas > 0 ? [mk(M.front, m, "Porta", H - 8, doorsW(W, v.portas), v.portas, { edges: ALL, hinge: { qty: hingeQty(H), side: "C1" } })] : []),
    ];
  },
};


export const MODULES = [
  {
    key: "aereo",
    name: "Armário aéreo de cozinha",
    desc: "Caixa com 0 a 4 portas e prateleiras por vão. Com 3 portas cria 1 divisória (vão maior à esquerda ou à direita); com 4 portas, divisória no centro.",
    materials: BOX,
    params: dims([800, 200, 2000], [700, 200, 1500], [350, 150, 600], [
      { key: "portas", label: "Portas (0 = sem porta)", def: 2, min: 0, max: 4 },
      { key: "lado_maior", label: "Vão maior (2 portas)", def: 0, choices: [[0, "À esquerda"], [1, "À direita"]], when: (v) => v.portas === 3 },
      { key: "div_pos", label: "Divisória vertical", def: 0, choices: [[0, "Sem divisória"], [1, "Lado esquerdo"], [2, "Centro"], [3, "Lado direito"]], when: (v) => v.portas === 0 },
      { ...divParam(0), when: (v) => v.portas > 0 && v.portas < 3 },
      ...bayRows(1, false, false, (v) => (v.portas >= 3 ? 1 : v.portas === 0 ? (v.div_pos > 0 ? 1 : 0) : v.divisorias)),
    ]),
    build: (v, M) => {
      const T = M.body.thickness, m = "Armário aéreo", b = backOpt(v, M), D = v.profundidade, inner = v.largura - 2 * T;
      return [
        mk(M.body, m, "Lateral", v.altura, D, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base / Topo", inner, D, 2, { edges: FRONT, ...b.rab }),
        ...wardrobeInside(M, m, v, T, inner, D - b.rw, true, false),
        ...wardrobeBacks(M, m, b, v, T, inner, 2),
        ...(v.portas > 0 ? [mk(M.front, m, "Porta", v.altura - 8, doorsW(v.largura, v.portas), v.portas, { edges: ALL, hinge: { qty: hingeQty(v.altura), side: "C1" } })] : []),
      ];
    },
  },
  {
    key: "balcao",
    name: "Gaveteiro de cozinha",
    desc: "Balcão com travessas superiores e gavetas com corrediças.",
    materials: BOX,
    params: dims([600, 300, 1200], [720, 400, 1000], [550, 300, 700], [{ key: "gavetas", label: "Gavetas", def: 3, min: 1, max: 5 }]),
    build: (v, M) => {
      const T = M.body.thickness, m = "Balcão gaveteiro", b = backOpt(v, M);
      return [
        mk(M.body, m, "Lateral", v.altura, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base", v.largura - 2 * T, v.profundidade, 1, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Travessa superior", v.largura - 2 * T, 100, 2, { edges: FRONT }),
        ...backPanel(M, m, b, v.largura, v.altura, T, 1),
        ...drawers(M, m, v.largura, v.profundidade - b.rw, T, splitFronts(v.altura, v.gavetas), undefined, { clear: v.altura - 2 * T }),
      ];
    },
  },
  {
    key: "balcao_inferior",
    name: "Balcão inferior de cozinha",
    desc: "Balcão com portas, prateleira e gavetas em cima ou numa coluna lateral.",
    materials: BOX,
    params: dims([800, 300, 1200], [720, 400, 1000], [550, 300, 700], [
      doorsParam(),
      shelvesParam(1, 3),
      { key: "gaveta_pos", label: "Posição das gavetas", def: 1, choices: [[0, "Sem gaveta"], [1, "Em cima"], [2, "Lateral lado A (esq.)"], [3, "Lateral lado B (dir.)"]] },
      { key: "gavetas", label: "Quantidade de gavetas", def: 1, min: 1, max: 6 },
      { key: "gaveta_largura", label: "Largura da coluna de gavetas (mm)", def: 400, min: 250, max: 900 },
    ]),
    build: (v, M) => {
      const T = M.body.thickness, m = "Balcão inferior", W = v.largura, H = v.altura, D = v.profundidade, b = backOpt(v, M);
      const pos = v.gaveta_pos;
      const side = pos === 2 || pos === 3;
      const gl = side ? Math.min(v.gaveta_largura, W - 250) : 0;
      const nTop = pos === 1 ? topDrawers(H, v.gavetas) : 0;
      const doorH = H - 8 - nTop * 154;
      const areaW = W - gl;
      const doorW = doorsW(areaW, v.portas);
      const shelfW = side ? areaW - T : W - 2 * T;
      return [
        mk(M.body, m, "Lateral", H, D, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base", W - 2 * T, D, 1, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Travessa superior", W - 2 * T, 100, 2, { edges: FRONT }),
        ...(side ? [mk(M.body, m, "Divisória da coluna de gavetas", H - T, D - b.rw, 1, { edges: FRONT })] : []),
        ...(v.prateleiras > 0 ? [mk(M.body, m, "Prateleira", shelfW, D - 20 - b.rw, v.prateleiras, { edges: FRONT })] : []),
        ...backPanel(M, m, b, W, H, T, 1),
        ...(v.portas > 0 ? [mk(M.front, m, "Porta", doorH, doorW, v.portas, { edges: ALL, hinge: { qty: hingeQty(doorH), side: "C1" } })] : []),
        ...(pos === 1 ? drawers(M, m, W, D - b.rw, T, Array(nTop).fill(150)) : []),
        ...(side ? drawers(M, m, gl, D - b.rw, T, splitFronts(H, v.gavetas), undefined, { clear: H - 2 * T }) : []),
      ];
    },
  },
  {
    key: "guarda_roupa",
    name: "Guarda-roupa portas de abrir",
    desc: "De 0 a 6 portas de abrir, com maleiro, prateleiras e rodapé.",
    materials: BOX,
    params: dims([1000, 400, 2700], [2200, 1200, 2700], [550, 350, 700], [{ key: "portas", label: "Portas de abrir (0 = sem porta)", def: 2, min: 0, max: 6 }, ...wardrobeParams(2, true)]),
    build: (v0, M) => {
      const v = withRodape(v0);
      const T = M.body.thickness, m = `Guarda-roupa ${v.portas}P`, b = backOpt(v, M), D = v.profundidade;
      const doorW = doorsW(v.largura, v.portas);
      return [
        mk(M.body, m, "Lateral", v.altura, D, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base / Topo", v.largura - 2 * T, D, 2, { edges: FRONT, ...b.rab }),
        ...wardrobeInside(M, m, v, T, v.largura - 2 * T, D - b.rw, true),
        ...rodapeFrame(M, m, v, T, v.largura - 2 * T, D, bayWidths(v, v.largura - 2 * T, T).length - 1),
        ...wardrobeBacks(M, m, b, v, T, v.largura - 2 * T, 2),
        ...(v.portas > 0 ? [mk(M.front, m, "Porta", v.altura - 8, doorW, v.portas, { edges: ALL, hinge: { qty: hingeQty(v.altura), side: "C1" } })] : []),
      ];
    },
  },
  {
    key: "correr",
    name: "Guarda-roupa com portas de correr",
    desc: "Portas deslizantes com sobreposição, divisória, maleiro e prateleiras.",
    note: "Trilhos e roldanas não estão inclusos na lista de peças.",
    materials: BOX,
    params: dims([1800, 1000, 2700], [2400, 1500, 2700], [600, 450, 700], [
      { key: "portas", label: "Portas de correr", def: 2, choices: [[0, "Sem portas"], [2, "2 portas"], [3, "3 portas"], [4, "4 portas"]] },
      ...wardrobeParams(3),
    ]),
    build: (v0, M) => {
      const v = withRodape(v0);
      const T = M.body.thickness, m = "Guarda-roupa correr", b = backOpt(v, M);
      const inner = v.largura - 2 * T;
      const doorH = v.altura - 2 * T - 40;
      const doorW = v.portas ? (inner + (v.portas - 1) * 40) / v.portas : 0;
      return [
        mk(M.body, m, "Lateral", v.altura, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base / Topo", inner, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        ...wardrobeInside(M, m, v, T, inner, v.profundidade - 80, false),
        ...rodapeFrame(M, m, v, T, inner, v.profundidade, bayWidths(v, inner, T).length - 1),
        ...wardrobeBacks(M, m, b, v, T, inner, 2),
        ...(v.portas > 0 ? [mk(M.front, m, "Porta de correr", doorH, doorW, v.portas, { edges: ALL })] : []),
      ];
    },
  },
  NICHO_INFERIOR,
  {
    key: "banheiro",
    name: "Gabinete de banheiro",
    desc: "Gabinete para pia com portas de abrir ou basculante, gavetas em cima, embaixo ou na lateral.",
    materials: BOX,
    params: dims([800, 400, 1600], [600, 400, 900], [450, 300, 600], [
      { ...doorsParam(), when: (v) => v.porta_tipo === 0 },
      { key: "porta_tipo", label: "Tipo de porta", def: 0, choices: [[0, "Portas de abrir"], [1, "Porta basculante"], [2, "Basculante com gaveta"]] },
      shelvesParam(1, 2),
      { key: "gaveta_pos", label: "Gavetas", def: 0, choices: [[0, "Sem gaveta"], [1, "Em cima"], [2, "Embaixo"], [3, "Lateral A (esq.)"], [4, "Lateral B (dir.)"]] },
      { key: "gavetas", label: "Quantidade de gavetas", def: 1, min: 1, max: 4, when: (v) => v.gaveta_pos > 0 },
      { key: "gaveta_largura", label: "Largura da coluna de gavetas (mm)", def: 300, min: 250, max: 700, when: (v) => v.gaveta_pos > 2 },
    ]),
    build: (v, M) => {
      const T = M.body.thickness, m = "Gabinete banheiro", b = backOpt(v, M), W = v.largura, H = v.altura, D = v.profundidade;
      const pos = v.gaveta_pos === 0 && v.porta_tipo === 2 ? 2 : v.gaveta_pos, n = v.gaveta_pos === 0 ? 1 : v.gavetas;
      const side = pos > 2, gl = side ? Math.min(v.gaveta_largura, W - 250) : 0, stack = pos === 1 || pos === 2 ? n * 154 : 0;
      const areaW = W - gl, doorH = H - stack - 8;
      const doors = v.porta_tipo === 0
        ? (v.portas > 0 ? [mk(M.front, m, "Porta", doorH, doorsW(areaW, v.portas), v.portas, { edges: ALL, hinge: { qty: hingeQty(doorH), side: "C1" } })] : [])
        : [mk(M.front, m, "Porta basculante", areaW - 8, doorH, 1, { edges: ALL, hinge: { qty: 2, side: "C1" } })];
      return [
        mk(M.body, m, "Lateral", H, D, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base", W - 2 * T, D, 1, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Travessa superior", W - 2 * T, 80, 2, { edges: FRONT }),
        ...(side ? [mk(M.body, m, "Divisória da coluna de gavetas", H - T, D - b.rw, 1, { edges: FRONT })] : []),
        ...(stack ? [mk(M.body, m, "Prateleira divisória das gavetas", W - 2 * T, D - b.rw, 1, { edges: FRONT })] : []),
        ...(v.prateleiras > 0 ? [mk(M.body, m, "Prateleira", side ? areaW - T : W - 2 * T, D - 20 - b.rw, v.prateleiras, { edges: FRONT })] : []),
        ...backPanel(M, m, b, W, H, T, 1),
        ...doors,
        ...(stack ? drawers(M, m, W, D - b.rw, T, Array(n).fill(150)) : []),
        ...(side ? drawers(M, m, gl, D - b.rw, T, splitFronts(H, n), undefined, { clear: H - 2 * T }) : []),
      ];
    },
  },
  {
    key: "espelheira",
    name: "Armário de banheiro (espelheira)",
    desc: "Armário suspenso raso com portas e prateleiras.",
    materials: BOX,
    params: dims([600, 300, 1400], [700, 300, 1000], [150, 100, 300], [doorsParam(1), shelvesParam(2, 4)]),
    build: (v, M) => cabinetWithDoors(v, M, "Espelheira"),
  },
  {
    key: "gaveteiro",
    name: "Gaveteiro simples",
    desc: "Caixa com topo, base e gavetas iguais.",
    materials: BOX,
    params: dims([450, 250, 1000], [700, 300, 1200], [500, 300, 700], [{ key: "gavetas", label: "Gavetas", def: 4, min: 1, max: 6 }]),
    build: (v, M) => {
      const T = M.body.thickness, m = "Gaveteiro", b = backOpt(v, M);
      return [
        mk(M.body, m, "Lateral", v.altura, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base / Topo", v.largura - 2 * T, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        ...backPanel(M, m, b, v.largura, v.altura, T, 2),
        ...drawers(M, m, v.largura, v.profundidade - b.rw, T, splitFronts(v.altura, v.gavetas), undefined, { clear: v.altura - 2 * T }),
      ];
    },
  },
  {
    key: "nicho",
    name: "Nicho / prateleira",
    desc: "Nicho aberto com ou sem fundo e divisões.",
    materials: ["body", "back"],
    params: dims([600, 150, 2000], [300, 100, 1500], [250, 100, 600], [
      { key: "prateleiras", label: "Prateleiras internas", def: 0, min: 0, max: 4 },
      { key: "fundo", label: "Com fundo (0 = não, 1 = sim)", def: 1, min: 0, max: 1 },
    ]),
    build: (v, M) => {
      const T = M.body.thickness, m = "Nicho", b = backOpt(v.fundo ? v : { fundo_tipo: 0 }, M);
      return [
        mk(M.body, m, "Lateral", v.altura, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        mk(M.body, m, "Base / Topo", v.largura - 2 * T, v.profundidade, 2, { edges: FRONT, ...b.rab }),
        ...(v.prateleiras > 0 ? [mk(M.body, m, "Prateleira", v.largura - 2 * T, v.profundidade - (v.fundo ? (b.emb ? b.rw : M.back.thickness) : 0), v.prateleiras, { edges: FRONT })] : []),
        ...(v.fundo ? backPanel(M, m, b, v.largura, v.altura, T, 2) : []),
      ];
    },
  },
  {
    key: "ripado",
    name: "Painel ripado",
    desc: "Ripas verticais com espaçamento auto ajustado (com espaço no início e no fim) e furação Ø8 (T9) nas ripas e no painel.",
    info: (v) => {
      const { n, gap, cnt, spaces, hz, H, len } = ripado(v);
      const clamped = spaces < v.espacos ? ` · atenção: só cabem ${spaces} espaços nessa medida` : "";
      const hzNote = hz && (H !== v.altura || len !== v.largura) ? ` · horizontal: altura ${H} mm (300 a 1820), ripa ${len} mm` : "";
      return `Espaçamento auto ajustado: ${gap.toFixed(1).replace(".", ",")} mm · ${n} ripas · ${spaces} espaços · ${cnt} furos Ø8 por ripa${clamped}${hzNote}`;
    },
    materials: ["front", "back"],
    labels: { front: "Ripas", back: "Painel de fundo" },
    params: [
      { key: "largura", label: "Largura do painel (mm)", def: 1200, min: 200, max: 6000 },
      { key: "altura", label: "Altura (mm)", def: 2400, min: 300, max: 2730 },
      { key: "ripa", label: "Largura da ripa (mm)", def: 40, min: 40, max: 200 },
      { key: "orientacao", label: "Direção das ripas", def: 0, choices: [[0, "Vertical"], [1, "Horizontal"]] },
      { key: "inicio", label: "Início e fim do painel", def: 0, choices: [[0, "Com espaçamento"], [1, "Com a ripa"]] },
      { key: "espacos", label: "Quantidade de espaçamentos", def: 21, min: 2, max: 150 },
      { key: "fundo", label: "Painel de fundo", def: 1, choices: [[1, "Com painel"], [0, "Sem painel"]] },
      { key: "furo_painel", label: "Furo no painel", def: 0, choices: [[0, "Até a metade da espessura"], [1, "Atravessar (+1 mm)"]], when: (v) => v.fundo === 1 },
    ],
    build: (v, M) => {
      const m = "Painel ripado", { n, gap, ys, start, hz, H, len, W } = ripado(v);
      const rd = M.front.thickness <= 6 ? 3 : 10, pt = M.back.thickness, pd = v.furo_painel ? pt + 1 : r1(pt / 2);
      const ripa = mk(M.front, m, "Ripa", len, v.ripa, n, { edges: LONG, grain: true, drills: ys.map((y) => ({ x: y, y: v.ripa / 2, depth: rd })) });
      const cs = Array.from({ length: n }, (_, i) => r1(start + i * (v.ripa + gap) + v.ripa / 2));
      const pts = cs.flatMap((c) => ys.map((y) => (hz ? { x: y, y: c, depth: pd } : { x: c, y, depth: pd })));
      const back = !v.fundo ? [] : fitsSheet(W, H)
        ? [mk(M.back, m, "Painel de fundo (furado)", W, H, 1, { drills: pts })]
        : panel(M.back, m, "Painel de fundo", W, H, 1);
      return [ripa, ...back];
    },
  },
  {
    key: "canto",
    name: "Tampo / prateleira com cantos arredondados",
    desc: "Peça com raio nos cantos escolhidos, cortada direto na CNC. Pode ser tamponada.",
    materials: ["body"],
    params: [
      { key: "comprimento", label: "Comprimento (mm)", def: 1200, min: 100, max: 2730 },
      { key: "largura", label: "Largura (mm)", def: 400, min: 60, max: 1830 },
      { key: "raio", label: "Raio do canto (mm)", def: 50, min: 3, max: 400 },
      ...[["C1L1", "Canto frente esquerda (C1+L1)"], ["C1L2", "Canto frente direita (C1+L2)"], ["C2L1", "Canto fundo esquerda (C2+L1)"], ["C2L2", "Canto fundo direita (C2+L2)"]]
        .map(([key, label]) => ({ key, label, def: 1, choices: [[1, "Arredondar"], [0, "Reto"]] })),
      { key: "tampon", label: "Tamponamento", def: 0, choices: [[0, "Sem tamponamento"], [1, "Peça inteira"], [2, "Régua na frente"], [3, "Régua em volta"]] },
      { key: "tampon_largura", label: "Largura da régua (mm)", def: 50, min: 15, max: 400 },
      { key: "tampon_esp", label: "Espessura do tamponamento", def: 18, choices: [[6, "6mm"], [15, "15mm"], [18, "18mm"], [25, "25mm"]] },
      { key: "quantidade", label: "Quantidade", def: 1, min: 1, max: 50 },
    ],
    build: (v, M) => {
      const radius = Math.min(v.raio, Math.floor(Math.min(v.comprimento, v.largura) / 2));
      const corners = { C1L1: !!v.C1L1, C1L2: !!v.C1L2, C2L1: !!v.C2L1, C2L2: !!v.C2L2 };
      const anyRound = Object.values(corners).some(Boolean);
      const tampon = v.tampon ? {
        enabled: true, type: v.tampon === 1 ? "dupla" : "regua", width: v.tampon_largura, thickness: v.tampon_esp,
        sides: v.tampon === 3 ? ALL : FRONT,
      } : undefined;
      return [mk(M.body, "Cantos arredondados", anyRound ? "Tampo arredondado" : "Tampo", v.comprimento, v.largura, v.quantidade, {
        edges: ALL, radius: anyRound ? radius : 0, corners, ...(tampon ? { tampon } : {}),
      })];
    },
  },
  {
    key: "provencal",
    name: "Porta provençal",
    desc: "Moldura vazada cortada na CNC: primeiro o corte interno, depois o externo, sempre em 2 passadas.",
    note: "No G-code a passada 1 é feita em todas as portas provençal antes da passada 2.",
    materials: ["front"],
    labels: { front: "Cor do MDF da porta" },
    params: [
      { key: "largura", label: "Largura da porta (mm)", def: 400, min: 100, max: 700 },
      { key: "altura", label: "Altura da porta (mm)", def: 700, min: 100, max: 2700 },
      { key: "moldura", label: "Largura da moldura (mm)", def: 60, min: 25, max: 150 },
      { key: "espessura", label: "Espessura do MDF", def: 18, choices: [[6, "6mm"], [15, "15mm"], [18, "18mm"]] },
      { key: "quantidade", label: "Quantidade", def: 1, min: 1, max: 50 },
      { key: "veio", label: "Seguir veio do MDF", hint: "A peça não será girada na chapa", switch: true, def: 0, choices: [[0, "Não"], [1, "Sim"]] },
    ],
    build: (v, M) => {
      const fw = Math.max(25, Math.min(v.moldura, Math.floor((Math.min(v.largura, v.altura) - 15) / 2)));
      return [mk({ ...M.front, thickness: v.espessura }, "Porta provençal", `Porta provençal (moldura ${fw}mm)`, v.altura, v.largura, v.quantidade,
        { thickness: v.espessura, grain: v.veio === 1, frame: { enabled: true, width: fw } })];
    },
  },
  {
    key: "rodape",
    name: "Rodapés / Rodateto",
    desc: "Rodapé ou rodateto com até 2700 mm de comprimento por peça.",
    materials: ["front"],
    labels: { front: "Rodapé / rodateto" },
    params: [
      { key: "tipo", label: "Tipo da peça", def: 0, choices: [[0, "Rodapé"], [1, "Rodateto"]] },
      { key: "comprimento", label: "Comprimento (máx. 2700 mm)", def: 2000, min: 100, max: 2700 },
      { key: "altura", label: "Altura (mín. 30 mm)", def: 100, min: 30, max: 400 },
      { key: "quantidade", label: "Quantidade de peças", def: 1, min: 1, max: 50 },
    ],
    build: (v, M) => {
      const n = v.tipo === 1 ? "Rodateto" : "Rodapé";
      return [mk(M.front, `${n}s`, n, v.comprimento, v.altura, v.quantidade, { edges: TOP, grain: true })];
    },
  },
];

function lCorner(v, M, m, kind) {
  const T = M.body.thickness, Tf = M.front.thickness, A = v.lado_a, B = v.lado_b, H = v.altura;
  const Da = v.profundidade_a, Db = v.profundidade_b;
  const NO = { C1: false, C2: false, L1: false, L2: false };
  const lp = (name, inset, qty, slot = true, shallow = inset > 0) => {
    const L = A - T - inset, W = B - T - inset, da = shallow ? Da - 20 : Da, db = shallow ? Db - 20 : Db;
    return mk(M.body, m, slot ? `${name} c/ encaixe da régua` : name, L, W, qty, { edges: NO, notch: { enabled: true, length: L - db, width: W - da, edge: true },
      ...(slot ? { slot: { enabled: true, length: v.regua + 1, width: T + 1 } } : {}) });
  };
  const sup = kind === "superior";
  const out = [
    mk(M.body, m, "Lateral lado A", H, Da, 1, { edges: FRONT }),
    mk(M.body, m, "Lateral lado B", H, Db, 1, { edges: FRONT }),
    lp("Base em L (peça única)", 0, 1, !sup),
  ];
  if (kind === "inferior") {
    out.push(mk(M.body, m, "Travessa lado A", A - T, 100, 2, { edges: FRONT }));
    out.push(mk(M.body, m, "Travessa lado B", B - T - Da, 100, 2, { edges: FRONT }));
  } else {
    out.push(lp("Topo em L (peça única)", 0, 1, !sup));
  }
  if (kind === "roupa") {
    out.push(lp("Maleiro em L (peça única)", 0, 1, true, true));
    out.push(mk(M.body, m, "Rodapé lado A", A - T, 100, 1, { edges: FRONT }));
    out.push(mk(M.body, m, "Rodapé lado B", B - T - Da, 100, 1, { edges: FRONT }));
  }
  if (v.prateleiras > 0) {
    out.push(lp("Prateleira em L (peça única)", 0, v.prateleiras, true, true));
  }
  // superior: between base and top; inferior: up to the travessa; guarda-roupa: full side height
  const rH = sup ? H - 2 * T : kind === "inferior" ? H - T : H;
  out.push(mk(M.body, m, `Régua vertical lado A (${v.regua}mm)`, rH, v.regua, 1, { edges: FRONT }));
  out.push(...panel(M.back, m, "Fundo lado A", A - 2, H - 2, 1));
  out.push(...panel(M.back, m, "Fundo lado B", B - T - 6, H - 2, 1));
  if (v.portas === 0) return out;
  const doorH = H - 8;
  const aFront = v.porta_frente === 0;
  const wA = A - Db - T - 4 + (aFront ? Tf : 0), wB = B - Da - T - 4 + (aFront ? 0 : Tf);
  out.push(mk(M.front, m, `Porta lado A (${aFront ? "na frente" : "por trás"})`, doorH, wA, 1, { edges: ALL, hinge: { qty: hingeQty(doorH), side: "C1" } }));
  out.push(mk(M.front, m, `Porta lado B (${aFront ? "por trás" : "na frente"})`, doorH, wB, 1, { edges: ALL, hinge: { qty: hingeQty(doorH), side: "C1" } }));
  return out;
}

const lParams = (a, b, h, d, shelves) => [
  { key: "lado_a", label: "Lado A (mm)", def: a, min: 400, max: 2700 },
  { key: "lado_b", label: "Lado B (mm)", def: b, min: 400, max: 2700 },
  { key: "altura", label: "Altura (mm)", def: h[0], min: h[1], max: h[2] },
  { key: "profundidade_a", label: "Profundidade lado A (mm)", def: d, min: 150, max: 700 },
  { key: "profundidade_b", label: "Profundidade lado B (mm)", def: d, min: 150, max: 700 },
  { key: "regua", label: "Largura da régua vertical lado A (mm)", def: 70, min: 30, max: 200 },
  shelvesParam(shelves, 6),
  { key: "portas", label: "Portas", def: 2, choices: [[2, "Com 2 portas"], [0, "Sem portas"]] },
  { key: "porta_frente", label: "Qual porta fica na frente (maior, cobrindo a outra)", def: 0, choices: [[0, "Porta lado A"], [1, "Porta lado B"]], when: (v) => v.portas !== 0 },
];

MODULES.push(
  { key: "canto_inferior", name: "Canto em L — inferior de cozinha", desc: "Balcão de canto em L com travessas, régua de fundo vertical na quina, prateleira e 2 portas (ou sem portas).", materials: BOX,
    params: lParams(900, 900, [720, 400, 1000], 550, 1), build: (v, M) => lCorner(v, M, "Canto L inferior", "inferior"), lshape: true },
  { key: "canto_superior", name: "Canto em L — superior de cozinha", desc: "Aéreo de canto em L com régua de fundo vertical na quina, prateleiras e 2 portas (ou sem portas).", materials: BOX,
    params: lParams(650, 650, [700, 300, 1200], 350, 1), build: (v, M) => lCorner(v, M, "Canto L superior", "superior"), lshape: true },
  { key: "canto_roupa", name: "Canto em L — guarda-roupa", desc: "Guarda-roupa de canto em L com maleiro, rodapé, régua de fundo vertical na quina e 2 portas (ou sem portas).", materials: BOX,
    params: lParams(1200, 1200, [2200, 1500, 2700], 550, 2), build: (v, M) => lCorner(v, M, "Canto L guarda-roupa", "roupa"), lshape: true },
);

const BACK_KEYS = ["aereo", "balcao", "balcao_inferior", "guarda_roupa", "correr", "banheiro", "espelheira", "gaveteiro", "nicho", "nicho_inferior"];
const DOOR_DEPTH = ["aereo", "nicho_inferior", "balcao", "balcao_inferior", "guarda_roupa", "banheiro", "espelheira", "gaveteiro"];
// Typed depth is the final depth: subtract front (doors/drawer fronts) and an overlaid back
const hasFront = (key, v) => DOOR_DEPTH.includes(key) && (!v.montagem || v.montagem === 3) && (v.portas !== 0 || v.gaveta_pos > 0 || v.porta_tipo > 0);
export const caixaDepth = (key, v, M) => v.profundidade
  - (hasFront(key, v) ? M.front.thickness : 0)
  - (v.fundo_tipo === 0 && (key !== "nicho" || v.fundo) ? M.back.thickness : 0);
MODULES.filter((m) => BACK_KEYS.includes(m.key)).forEach((m) => {
  m.params.push(fundoParam);
  m.backNote = true;
  const build = m.build;
  m.build = (v, M) => build({ ...v, profundidade: caixaDepth(m.key, v, M) }, M);
});

const DRAWER_KEYS = ["balcao", "balcao_inferior", "gaveteiro", "guarda_roupa", "correr", "banheiro"];
MODULES.filter((m) => DRAWER_KEYS.includes(m.key)).forEach((m) => {
  m.materials = [...BOX, "drawer"];
  m.slides = true;
});

// Doors / external drawer fronts: overlaid, inset (4 mm gaps inside the box opening) or none
const MOUNT_KEYS = ["aereo", "balcao", "balcao_inferior", "guarda_roupa", "banheiro", "espelheira", "gaveteiro", "nicho_inferior", "canto_inferior", "canto_superior", "canto_roupa"];
const isDoor = (p) => /^Porta/.test(p.name) && !/correr/i.test(p.name);
const isFront = (p) => p.name === "Frente de gaveta" && !p.internal;
const applyMount = (pieces, v, M) => {
  if (!v.montagem) return pieces;
  // glass doors: overlaid like "por fora", but the doors are not cut from MDF
  if (v.montagem === 3) return pieces.filter((p) => !isDoor(p));
  if (v.montagem === 2) return pieces.filter((p) => !isDoor(p) && !isFront(p));
  const T = M.body.thickness, rec = M.front.thickness + 5;
  const nd = pieces.filter(isDoor).reduce((a, p) => a + p.qty, 0), nf = pieces.filter(isFront).reduce((a, p) => a + p.qty, 0);
  const kV = (nd ? 1 : 0) + nf;
  if (!kV) return pieces;
  return pieces.map((p) => {
    if (isDoor(p)) return { ...p, length: r(p.length - (2 * T) / kV), width: r(p.width - (2 * T) / nd) };
    if (isFront(p)) return { ...p, length: r(p.length - 2 * T), width: r(p.width - (2 * T) / kV) };
    // inside parts set back door thickness + 5 mm from the front
    if (/^(Prateleira|Divisória|Maleiro|Lateral afastador|Tampo do gaveteiro)/.test(p.name) && !/em L/.test(p.name)) return { ...p, width: r(p.width - rec) };
    return p;
  });
};
const FRONTS_ONLY = ["balcao", "gaveteiro"], BOTH = ["balcao_inferior", "banheiro"];
MODULES.filter((m) => MOUNT_KEYS.includes(m.key)).forEach((m) => {
  const L = m.key.startsWith("canto"), fo = FRONTS_ONLY.includes(m.key), both = BOTH.includes(m.key);
  const label = fo ? "Frentes" : both ? "Portas / frentes de gaveta" : "Portas";
  const none = [2, fo ? "Sem frente" : both ? "Sem porta / frente" : "Sem porta"], glass = fo || m.key === "balcao_inferior" ? [] : [[3, "Porta de vidro (por fora)"]];
  m.params.push({ key: "montagem", label, def: 0, choices: L ? [[0, "Por fora"], ...glass, none] : [[0, "Por fora"], [1, "Embutida"], ...glass, none] });
  const build = m.build;
  m.build = (v, M) => applyMount(build(v, v.montagem === 1 ? { ...M, inset: M.front.thickness } : M), v, M);
});

// Tamponamento on chosen outer faces (same options as the piece list); the box shrinks so the finished size stays as typed
const TAMP_KEYS = ["aereo", "balcao", "balcao_inferior", "guarda_roupa", "correr", "nicho_inferior", "banheiro", "espelheira", "gaveteiro", "nicho"];
const TAMP_TOP = ["aereo", "guarda_roupa", "correr", "espelheira", "gaveteiro", "nicho"];
const split = (p, k, tampon) => {
  const { id, ...rest } = p;
  return [...(k ? [newPiece({}, { ...rest, qty: k, tampon })] : []), ...(p.qty - k ? [newPiece({}, { ...rest, qty: p.qty - k })] : [])];
};
MODULES.filter((m) => TAMP_KEYS.includes(m.key)).forEach((m) => {
  const top = TAMP_TOP.includes(m.key), on = (v) => v.tamp > 0;
  const face = (key, label, def) => ({ key, label, hint: "Desconta a espessura na medida do móvel", switch: true, def, choices: [[0, "Não"], [1, "Sim"]], when: on });
  m.params.push(
    { key: "tamp", label: "Tamponamento", def: 0, choices: [[0, "Sem tamponamento"], [1, "Peça inteira"], [2, "Régua na frente"], [3, "Régua em volta"]] },
    { key: "tamp_esp", label: "Espessura do tamponamento", def: 18, choices: [[6, "6mm"], [15, "15mm"], [18, "18mm"], [25, "25mm"]], when: on },
    { key: "tamp_largura", label: "Largura da régua (mm)", def: 50, min: 15, max: 400, when: (v) => v.tamp >= 2 },
    face("tamp_le", "Tamponar lateral esquerda", 1), face("tamp_ld", "Tamponar lateral direita", 1),
    ...(top ? [face("tamp_topo", "Tamponar topo", 0)] : []), face("tamp_base", "Tamponar base", 0),
  );
  const build = m.build;
  m.build = (v, M) => {
    if (!v.tamp) return build(v, M);
    const e = v.tamp_esp, nL = (v.tamp_le ? 1 : 0) + (v.tamp_ld ? 1 : 0), nT = top && v.tamp_topo ? 1 : 0, nB = v.tamp_base ? 1 : 0;
    const tampon = { enabled: true, type: v.tamp === 1 ? "dupla" : "regua", width: v.tamp_largura, thickness: e, sides: v.tamp === 3 ? ALL : FRONT,
      mdf_color: M.tampon?.mdf_color || "", edge_color: M.tampon?.edge_color || "" };
    const bw = v.largura - e * nL, bh = v.altura - e * (nT + nB);
    const tag = ` · final ${v.largura}x${v.altura} / caixa ${bw}x${bh}`;
    const pieces = build({ ...v, largura: bw, altura: bh }, M).map((p) => ({ ...p, module: p.module + tag }));
    return pieces.flatMap((p) => {
      // laterals' tamponamento runs past the tamponed top/base; top/base tamponamento covers the laterals' edges
      const T = M.body.thickness;
      if (p.name === "Lateral") return split(p, Math.min(nL, p.qty), { ...tampon, extra: e * (nT + nB) });
      if (p.name === "Base / Topo") return split(p, Math.min(nT + nB, p.qty), { ...tampon, extra: 2 * T });
      if (p.name === "Base") return split(p, Math.min(nB, p.qty), { ...tampon, extra: 2 * T });
      return [p];
    });
  };
});

// L corners: tamponed end laterals shorten their side (A or B); top/base shorten the height
const TAMP_L = ["canto_inferior", "canto_superior", "canto_roupa"];
MODULES.filter((m) => TAMP_L.includes(m.key)).forEach((m) => {
  const top = m.key !== "canto_inferior", on = (v) => v.tamp > 0;
  const face = (key, label, def) => ({ key, label, hint: "Desconta a espessura na medida do móvel", switch: true, def, choices: [[0, "Não"], [1, "Sim"]], when: on });
  m.params.push(
    { key: "tamp", label: "Tamponamento", def: 0, choices: [[0, "Sem tamponamento"], [1, "Peça inteira"], [2, "Régua na frente"], [3, "Régua em volta"]] },
    { key: "tamp_esp", label: "Espessura do tamponamento", def: 18, choices: [[6, "6mm"], [15, "15mm"], [18, "18mm"], [25, "25mm"]], when: on },
    { key: "tamp_largura", label: "Largura da régua (mm)", def: 50, min: 15, max: 400, when: (v) => v.tamp >= 2 },
    face("tamp_la", "Tamponar lateral lado A", 1), face("tamp_lb", "Tamponar lateral lado B", 1),
    ...(top ? [face("tamp_topo", "Tamponar topo", 0)] : []), face("tamp_base", "Tamponar base", 0),
  );
  const build = m.build;
  m.build = (v, M) => {
    if (!v.tamp) return build(v, M);
    const e = v.tamp_esp, nT = top && v.tamp_topo ? 1 : 0, nB = v.tamp_base ? 1 : 0;
    const tampon = { enabled: true, type: v.tamp === 1 ? "dupla" : "regua", width: v.tamp_largura, thickness: e, sides: v.tamp === 3 ? ALL : FRONT,
      mdf_color: M.tampon?.mdf_color || "", edge_color: M.tampon?.edge_color || "" };
    const ba = v.lado_a - (v.tamp_la ? e : 0), bb = v.lado_b - (v.tamp_lb ? e : 0), bh = v.altura - e * (nT + nB);
    const tag = ` · final A${v.lado_a} B${v.lado_b} H${v.altura} / caixa A${ba} B${bb} H${bh}`;
    const pieces = build({ ...v, lado_a: ba, lado_b: bb, altura: bh }, M).map((p) => ({ ...p, module: p.module + tag }));
    const want = (p) => (p.name === "Lateral lado A" && v.tamp_la) || (p.name === "Lateral lado B" && v.tamp_lb)
      || (p.name.startsWith("Topo em L") && nT) || (p.name.startsWith("Base em L") && nB);
    return pieces.map((p) => (want(p) ? { ...p, tampon } : p));
  };
});



export const MATERIAL_LABELS = { body: "Caixa", front: "Portas / frentes", back: "Fundo", drawer: "Caixa da gaveta", tampon: "Tamponamento" };
export const defaultValues = (mod) => Object.fromEntries(mod.params.map((p) => [p.key, p.def]));
export const defaultMaterials = (d) => ({
  body: { thickness: d.thickness, mdf_color: d.mdf_color, edge_color: d.edge_color },
  front: { thickness: d.thickness, mdf_color: d.mdf_color, edge_color: d.edge_color },
  back: { thickness: 6, mdf_color: d.mdf_color, edge_color: "" },
  drawer: { thickness: 15, mdf_color: d.mdf_color, edge_color: d.edge_color },
  tampon: { thickness: 18, mdf_color: d.mdf_color, edge_color: d.edge_color },
  slide: "telescopica",
});
